import { DEFAULT_CONTRACT_LABEL } from '@constants'
import { formatPointsWithCommas } from '@utils/formattingUtils'
import type { MeUserMembership } from '@shared/types/me'
import type { ContractDetails } from '@shared/types/membership'

export function toContractDetails(memberships?: MeUserMembership[]): ContractDetails[] {
  if (!Array.isArray(memberships) || memberships.length === 0) return []

  return memberships.map((membership) => ({
    memberNumber: membership.id ?? 'N/A',
    contractType: membership.contractType ?? 'N/A',
    points: formatPointsWithCommas(String(membership.credits?.balance ?? 0)),
    currency: membership.credits?.currency ?? 'credits',
    tier: membership.level?.label ?? DEFAULT_CONTRACT_LABEL,
  }))
}
